import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MasonryWall from '@yeger/vue-masonry-wall'

// Import native Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// --- FONT AWESOME SETUP (START) ---
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import the specific icons you want to use
import { faFilm, faSearchPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'

// Add icons to the library
library.add(faFilm, faSearchPlus, faSpinner)
// --- FONT AWESOME SETUP (END) ---

// Import other plugins
import VueScrollTo from 'vue-scrollto'

// Create and configure the app
const app = createApp(App)

// Register the <font-awesome-icon> component globally
app.component('font-awesome-icon', FontAwesomeIcon)

// Use plugins
app.use(store)
app.use(router)
app.use(VueScrollTo)
app.use(MasonryWall)

// Mount the app
app.mount('#app')
